export default {
  name: 'product',
  title: 'Product',
  type: 'document',
  fields: [
    {
      name: 'supplier',
        title: 'Fornitore',
        type: 'reference',
        validation: Rule => Rule.required(),
        to: [{ type: 'supplier' }],
        
      },

    { 
      name: 'name',
      title: 'NomeProdotto',
      type: 'string',
    },
    { 
      name: 'price',
      title: 'Prezzo',
      type: 'number',
    },
    { 
      name: 'details',
      title: 'Descrizione',
      type: 'richTextObject',
    },
    { 
      name: 'productCode',
      title: 'CodiceProdottoFornitore',
      type: 'string',
    },
    { 
      name: 'slug',
      title: 'Slug',
      type: 'slug',
      options: {
        source: 'name',
        maxLength: 90,
      },
      
      
    },
    {
      name: 'image',
      title: 'Photo',
      type: 'array',
      of: [{ type: 'image' }],
      options: {
        hotspot: true,
      }
    },

    

  ]
}